import {gtmId, isBrowser} from "../../app/utils/read_environment_variables";

export const isValidGtmId = (id?: string | null): id is string => Boolean(id && /^GTM-[A-Z0-9]+$/i.test(id));

const ensureDataLayer = () => {
    if (!isBrowser) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
};

/**
 * Pushes a payload to GTM dataLayer.
 * Always queues events on the client so they are available once the GTM container loads.
 */
export const hitGoogleTagManager = (payload: Record<string, unknown>) => {
    if (!isBrowser) {
        return;
    }

    ensureDataLayer();
    window.dataLayer.push(payload);
};

let gtmInitialized = false;

/**
 * Loads GTM container once on the client when GTM_ID looks valid.
 * Skips if the container script was already injected by SSR.
 */
export const initGoogleTagManager = (id: string = gtmId) => {
    if (!isBrowser || gtmInitialized || !isValidGtmId(id)) {
        return;
    }

    gtmInitialized = true;
    ensureDataLayer();

    const alreadyLoaded = Boolean(document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${id}"]`));
    if (alreadyLoaded) {
        return;
    }

    window.dataLayer.push({"gtm.start": new Date().getTime(), event: "gtm.js"});

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(script);
};
